
<table class="table table-dark mainTable">
  <thead class="mainTableThead">
  <tr class="darkHeader">
    <!--        <th scope="col">Pull</th>-->
    <th *ngIf="exchangeName !== EXCHANGES.bitfinexSwap" class="text-center" scope="col">ABOS Account</th>
    <th *ngIf="exchangeName === EXCHANGES.bitfinexSwap" class="text-center" scope="col">Bitfinex Account</th>
    <th *ngIf="exchangeName !== EXCHANGES.bitfinexSwap" class="text-center" scope="col">ABOS Portfolio</th>
    <th scope="col">Positions</th>
    <th *ngIf="exchangeName === EXCHANGES.bitfinex || exchangeName === EXCHANGES.bitfinexSwap" class="text-center" scope="col">Push</th>
  </tr>
  </thead>
  <tbody class="mainTableBody">
  <tr class="mainRow">
    <!--      <td class="text-center mainCell" style="vertical-align: middle; width:5%">-->
    <!--        <div>-->
    <!--          <button style="width: 60px" type="button" class="btn btn-primary mt-1" (click)="pull(item.account.abosAccountId)">Pull</button>-->
    <!--        </div>-->
    <!--      </td>-->
    <td class="mainCell text-center pb-0" style="width:20%">
      <table class="thinBorder abosAccountTable table-dark mb-1 w-100">
        <tbody>
        <tr *ngIf="exchangeName !== EXCHANGES.bitfinexSwap">
          <td class="text-left">ABOS</td>
        </tr>
        <tr *ngIf="exchangeName !== EXCHANGES.bitfinexSwap">
          <td class="text-right"><b class="abosAccountName">{{item.account.abosAccountId + ' (' + item.account.abosAccountName + ' )'}}</b></td>
        </tr>
        <!--          <tr>-->
        <!--            <td class="d-flex justify-content-between">-->
        <!--              <span *ngIf="item.abos">Ratio:</span>-->
        <!--              <ng-select-->
        <!--                [ngClass]="isSelectorDisabled[item.abos.account.abosAccountId] ? 'disabledSelector' : ''"-->
        <!--                [disabled]="isSelectorDisabled[item.abos.account.abosAccountId]"-->
        <!--                [@signalChange]="isRatioAnimationRunning[item.abos.account.abosAccountId] ? 'running' : 'stopped'"-->
        <!--                class="ratioDropdown"-->
        <!--                *ngIf="item.abos && ratioForAbosAccounts"-->
        <!--                [items]="abosAccountRatioDropdown"-->
        <!--                [closeOnSelect]="true"-->
        <!--                [searchable]="false"-->
        <!--                [clearable]="false"-->
        <!--                bindLabel="ratio"-->
        <!--                placeholder="Select ratio"-->
        <!--                (ngModelChange)="emitAbosAccountRatioChange($event, item.abos.account.abosAccountId)"-->
        <!--                [(ngModel)]="ratioForAbosAccounts[item.abos.account.abosAccountId]">-->
        <!--              </ng-select>-->
        <!--            </td>-->
        <!--          </tr>-->
        <tr *ngIf="exchangeName !== EXCHANGES.bitfinexSwap">
          <td class="text-left">{{exchangeName | titlecase}}</td>
        </tr>
        <tr *ngIf="exchangeName === EXCHANGES.bitfinexSwap">
          <td class="text-left">Bitfinex swap</td>
        </tr>
        <tr *ngIf="exchangeName === EXCHANGES.bitfinex || exchangeName === EXCHANGES.bitfinexSwap">
          <td class="text-right"><b class="abosAccountName">{{item.account.bitfinexAccountName}}</b></td>
        </tr>
        <tr *ngIf="exchangeName === EXCHANGES.bitfinex">
          <td class="text-left">
            <div>
              <button style="width: 60px" type="button" class="btn btn-primary mt-1" (click)="pull(item.account.abosAccountId, item.account.bitfinexAccountId)">Pull</button>
            </div>
          </td>
        </tr>
        <tr *ngIf="exchangeName === EXCHANGES.bitfinexSwap">
          <td class="text-left">
            <div>
              <button style="width: 60px" type="button" class="btn btn-primary mt-1" (click)="pull(item.account.bitfinexAccountId, item.account.bitfinexAccountId)">Pull</button>
            </div>
          </td>
        </tr>
        <!--          <tr *ngIf="exchangeName === EXCHANGES.bitbay && !item.bitbay">-->
        <!--            <td class="text-right">-->
        <!--              No keys found for this account!-->
        <!--            </td>-->
        <!--          </tr>-->
        <!--          <tr *ngIf="exchangeName === EXCHANGES.bitfinex && !item.bitfinex">-->
        <!--            <td class="text-right">-->
        <!--              No keys found for this account!-->
        <!--            </td>-->
        <!--          </tr>-->
        </tbody>
      </table>
    </td>


    <td *ngIf="exchangeName !== EXCHANGES.bitfinexSwap" class="mainCell" style="width:20%">
      <table class="table table-dark thinBorder abosPortfolioTable">
        <tbody>
        <tr>
          <td class="text-left">Client Account Currency:</td>
          <td class="text-right" style="vertical-align: middle;">{{item.clientAccountCurrency}}</td>
        </tr>
        <tr>
          <td class="text-left">Cash Position:</td>
          <td class="text-right" style="vertical-align: middle;">{{item.cashPosition | number}}</td>
        </tr>
        <tr>
          <td class="text-left">Net Equity:</td>
          <td class="text-right" style="vertical-align: middle;">{{item.netEquityPosition | number}}</td>
        </tr>
        <tr>
          <td class="text-left">Net Open Position:</td>
          <td class="text-right" style="vertical-align: middle;">{{item.netOpenPosition | number}}</td>
        </tr>
        <tr>
          <td class="text-left">Unrealized Profit Or Loss:</td>
          <td class="text-right" style="vertical-align: middle;">{{item.unrealizedProfitOrLoss | number}}</td>
        </tr>
        <tr>
          <td class="text-left">Margin level:</td>
          <td class="text-right" style="vertical-align: middle;"><span *ngIf="item && item.netOpenPosition">{{(item.netEquityPosition * 100 / item.netOpenPosition) | number:'1.2-2'}} %</span></td>
        </tr>
        </tbody>
      </table>
    </td>


    <td class="text-center currencyTable mainCell scroll">
      <div *ngIf="exchangeName === EXCHANGES.bitfinex" class="scroll">
        <div class="table-responsive">
          <table class="table table-dark">
            <thead>
            <tr class="darkHeader">
              <th class="enabledCol align-middle ps-0" scope="col">
                <input class="form-check-input"
                       type="checkbox"
                       [(ngModel)]="allEnabledCheckboxStateForAccount[item.account.abosAccountId][item.account.bitfinexAccountId]"
                       (ngModelChange)="handle($event, item.account.abosAccountId, item.exchange === EXCHANGES.bitfinexSwap, item.account.bitfinexAccountId)">
              </th>
              <th class="currencyCol" scope="col">Currency</th>
              <th scope="col" class="text-right">ABOS</th>
              <th scope="col" class="text-right">{{exchangeName | titlecase}}</th>
              <th class="text-right pe-3 target-column-header" scope="col">Target {{flipped[item.account.abosAccountId] ? ' (USD)' : ''}}</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let ccy of currencies | orderBy:null:null:false:positionsComparator2.bind(this, item)" [ngClass]="showOnlyBitfinexEnabledAccounts && !wallet.availableBitfinexCCYS.includes(getMappedCurrency(ccy)) ? 'd-none' : ''">
              <td class="enabledCol" style="vertical-align: middle">
                <input class="form-check-input"
                       style="cursor: pointer; margin: 0 !important; position: relative;"
                       type="checkbox"
                       [(ngModel)]="isBitfinexTargetEnabled[item.account.abosAccountId][item.account.bitfinexAccountId][ccy]"
                       (ngModelChange)="emitBitfinexCurrencyEnabledChange($event, item.account.abosAccountId, item.account.bitfinexAccountId, ccy, false)">
              </td>
              <td class="text-center align-middle currencyCol">{{getMappedCurrency(ccy) === ccy ? ccy :(ccy + ' [' + getMappedCurrency(ccy) + ']')}}</td>
              <td class="text-right" style="vertical-align: middle;">{{item.ccyPositions[ccy]?.tradePosition | number:'1.2-4' }}</td>
              <!--                                                                        TODO check is ccy mapping is need here?-->
              <td class="text-right" style="vertical-align: middle;"><span class="me-3">{{item.ccyPositions[ccy]?.bitfinexPosition | number:'1.2-4' }}</span></td>
              <td class="bitfinexColumn">
                <div class="tp-wrapper">
                  <div class="tp-box" [@flipState]="flipped[item.account.abosAccountId] ? true : false">
                    <div class="tp-box__side tp-box__front">
                      <input [disabled]="!isBitfinexTargetEnabled[exchangeName === 'BITFINEX_SWAP' ? item.account.bitfinexAccountId : item.account.abosAccountId][item.account.bitfinexAccountId][ccy]"
                             [textMask]="{mask: mask}"
                             [ngClass]="!isBitfinexTargetEnabled[exchangeName === 'BITFINEX_SWAP' ? item.account.bitfinexAccountId : item.account.abosAccountId][item.account.bitfinexAccountId][ccy] ? 'disabledTargetInput' : ''"
                             class="form-control targetInput text-right"
                             type="text"
                             (ngModelChange)="recalculateTargetInUSD($event, item.account.abosAccountId, item.account.bitfinexAccountId, ccy)"
                             [(ngModel)]="target[exchangeName === 'BITFINEX_SWAP' ? item.account.bitfinexAccountId : item.account.abosAccountId][item.account.bitfinexAccountId][ccy]"/>
                    </div>
                    <div class="tp-box__side tp-box__back">
                      <input [disabled]="!isBitfinexTargetEnabled[exchangeName === 'BITFINEX_SWAP' ? item.account.bitfinexAccountId : item.account.abosAccountId][item.account.bitfinexAccountId][ccy]"
                             *ngIf="exchangeName === 'BITFINEX_SWAP' ? item.account.bitfinexAccountId : item.account.abosAccountId"
                             [textMask]="{mask: mask}"
                             [ngClass]="!isBitfinexTargetEnabled[exchangeName === 'BITFINEX_SWAP' ? item.account.bitfinexAccountId : item.account.abosAccountId][item.account.bitfinexAccountId][ccy] ? 'disabledTargetInput' : ''"
                             class="form-control targetInput text-right"
                             type="text"
                             (ngModelChange)="recalculateTargetGivenCurrency($event, item.account.abosAccountId, item.account.bitfinexAccountId, ccy)"
                             [(ngModel)]="targetInUSD[exchangeName === 'BITFINEX_SWAP' ? item.account.bitfinexAccountId : item.account.abosAccountId][item.account.bitfinexAccountId][ccy]"/>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div *ngIf="exchangeName === EXCHANGES.bitfinexSwap" class="scroll">
        <div class="table-responsive">
          <table class="table table-dark">
            <thead>
            <tr class="darkHeader">
              <th class="enabledCol" scope="col">
                <input class="form-check-input"
                       style="cursor: pointer; margin: 0 !important; position: relative;"
                       type="checkbox"
                       [(ngModel)]="allEnabledCheckboxStateForAccount[item.account.bitfinexAccountId][item.account.bitfinexAccountId]"
                       (ngModelChange)="handle($event, item.account.abosAccountId, item.exchange === EXCHANGES.bitfinexSwap, item.account.bitfinexAccountId)">
              </th>
              <th class="currencyCol" scope="col">Currency</th>
              <th scope="col">Bitfinex</th>
              <th class="targetCol" scope="col">Target {{flipped[item.account.bitfinexAccountId] ? ' (USD)' : ''}}</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let ccy of currencies | orderBy:null:null:false:positionsComparator2.bind(this, item)" [ngClass]="showOnlyBitfinexEnabledAccounts && !wallet.availableBitfinexCCYS.includes(getMappedCurrency(ccy)) ? 'd-none' : ''">
              <td class="enabledCol" style="vertical-align: middle">
                <input class="form-check-input"
                       style="cursor: pointer; margin: 0 !important; position: relative;"
                       type="checkbox"
                       [(ngModel)]="isBitfinexTargetEnabled[item.account.bitfinexAccountId][item.account.bitfinexAccountId][ccy]"
                       (ngModelChange)="emitBitfinexCurrencyEnabledChange($event, item.account.bitfinexAccountId, item.account.bitfinexAccountId, ccy, true)">
              </td>
              <td class="text-center align-middle currencyCol">{{getMappedCurrency(ccy) === ccy ? ccy :(ccy + ' [' + getMappedCurrency(ccy) + ']')}}</td>
              <td class="text-right" style="vertical-align: middle;"><span class="me-3">{{item.ccyPositions[ccy]?.bitfinexPosition | number:'1.2-4' }}</span></td>
              <td class="text-center d-flex justify-content-center bitfinexColumn targetCol">
                <div class="flipContainer">
                  <input [disabled]="!isBitfinexTargetEnabled[item.account.bitfinexAccountId][item.account.bitfinexAccountId][ccy]"
                         [textMask]="{mask: mask}"
                         [ngClass]="!isBitfinexTargetEnabled[item.account.bitfinexAccountId][item.account.bitfinexAccountId][ccy] ? 'disabledTargetInput' : ''"
                         class="form-control targetInput text-right"
                         type="text"
                         [(ngModel)]="target[item.account.bitfinexAccountId][item.account.bitfinexAccountId][ccy]"/>
                  <!--              <ngx-flip [flip]="flipped[item.account.bitfinexAccountId]">-->
                  <!--                <input front [disabled]="!isBitfinexTargetEnabled[item.account.bitfinexAccountId][ccy]"-->
                  <!--                       *ngIf="target[item.account.bitfinexAccountId]"-->
                  <!--                       [textMask]="{mask: mask}"-->
                  <!--                       [ngClass]="!isBitfinexTargetEnabled[item.account.bitfinexAccountId][ccy] ? 'disabledTargetInput' : ''"-->
                  <!--                       class="form-control targetInput text-right"-->
                  <!--                       type="text"-->
                  <!--                       (ngModelChange)="recalculateTargetInUSD($event, item.account.bitfinexAccountId, ccy)"-->
                  <!--                       [(ngModel)]="target[item.account.bitfinexAccountId][ccy]"/>-->
                  <!--                <input back [disabled]="!isBitfinexTargetEnabled[item.account.bitfinexAccountId][ccy]"-->
                  <!--                       *ngIf="target[item.account.bitfinexAccountId]"-->
                  <!--                       [textMask]="{mask: mask}"-->
                  <!--                       [ngClass]="!isBitfinexTargetEnabled[item.account.bitfinexAccountId][ccy] ? 'disabledTargetInput' : ''"-->
                  <!--                       class="form-control targetInput text-right"-->
                  <!--                       type="text"-->
                  <!--                       (ngModelChange)="recalculateTargetGivenCurrency($event, item.account.bitfinexAccountId, ccy)"-->
                  <!--                       [(ngModel)]="targetInUSD[item.account.bitfinexAccountId][ccy]"/>-->
                  <!--              </ngx-flip>-->
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </td>

    <td class="text-center mainCell align-middle" style="width:5%" *ngIf="exchangeName === EXCHANGES.bitfinex">
      <div>
        <div class="dropdown" *ngIf="item && item.account && item.account.abosAccountId">
          <button class="btn btn-primary dropdown-toggle" id="operationsDropdown" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="fa fa-2x fa-tasks" aria-hidden="true"></i>
          </button>
          <div class="dropdown-menu" aria-labelledby="operationsDropdown">
            <div class="dropdown-item" (click)="nullTarget(item.account.abosAccountId, item.account.bitfinexAccountId)">Null target</div>
            <div class="dropdown-divider"></div>
            <div class="dropdown-item" (click)="emptyTarget(item.account.abosAccountId, item.account.bitfinexAccountId)">Empty target</div>
            <div class="dropdown-divider"></div>
            <div class="dropdown-item" (click)="calculateDifferences(item.account.abosAccountId, item.account.bitfinexAccountId)">Recalculate target</div>
            <div class="dropdown-divider"></div>
            <div class="dropdown-item" (click)="enableAllCurrencyForAccount(item.account.abosAccountId, item.exchange === EXCHANGES.bitfinexSwap, item.account.bitfinexAccountId)">Enable all currency</div>
            <div class="dropdown-divider"></div>
            <div class="dropdown-item" (click)="disableAllCurrencyForAccount(item.account.abosAccountId, item.exchange === EXCHANGES.bitfinexSwap, item.account.bitfinexAccountId)">Disable all currency</div>
            <div class="dropdown-divider"></div>
            <div class="dropdown-item" (click)="flip(item.account.abosAccountId)">Flip to {{flipped[item.account.abosAccountId] ? 'original currencies' : 'USD'}}</div>
          </div>
        </div>
        <div class="mt-5">
          <button [disabled]="!pushEnabled || !currentUser.permissions.includes(PERMISSION_ENUM.BITFINEX_WRITE) || (isSelectorDisabled[item.account.abosAccountId] && isSelectorDisabled[item.account.abosAccountId][item.account.bitfinexAccountId])"
                  style="width: 60px"
                  type="button"
                  class="btn btn-primary" (click)="pushData(item)">Push
          </button>
        </div>
        <div></div>
      </div>
    </td>

    <td class="mainCell" style="width:5%; vertical-align: middle;" *ngIf="exchangeName === EXCHANGES.bitfinexSwap">
      <div>
        <!--          <div class="dropdown" *ngIf="item && item.account && item.account.bitfinexAccountId">-->
        <!--            <button class="btn btn-primary dropdown-toggle" id="operationsDropdownBfxSwap" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">-->
        <!--              <i class="fa fa-2x fa-tasks" aria-hidden="true"></i>-->
        <!--            </button>-->
        <!--            <div class="dropdown-menu" aria-labelledby="operationsDropdownBfxSwap">-->
        <!--              <div class="dropdown-item" (click)="nullTarget(item.account.bitfinexAccountId)">Null target</div>-->
        <!--              <div class="dropdown-divider"></div>-->
        <!--              <div class="dropdown-item" (click)="emptyTarget(item.account.bitfinexAccountId)">Empty target</div>-->
        <!--              <div class="dropdown-divider"></div>-->
        <!--              <div class="dropdown-divider"></div>-->
        <!--              <div class="dropdown-item" (click)="enableAllCurrencyForAccount(item.account.bitfinexAccountId)">Enable all currency</div>-->
        <!--              <div class="dropdown-divider"></div>-->
        <!--              <div class="dropdown-item" (click)="disableAllCurrencyForAccount(item.account.bitfinexAccountId)">Disable all currency</div>-->
        <!--              <div class="dropdown-divider"></div>-->
        <!--              <div class="dropdown-item" (click)="flip(item.account.bitfinexAccountId)">Flip to {{flipped[item.account.bitfinexAccountId] ? 'original currencies' : 'USD'}}</div>-->
        <!--            </div>-->
        <!--          </div>-->
        <div class="mt-5">
          <button [disabled]="!pushEnabled || !currentUser.permissions.includes(PERMISSION_ENUM.BITFINEX_SWAP_WRITE) || (isSelectorDisabled[item.account.bitfinexAccountId] && isSelectorDisabled[item.account.bitfinexAccountId][item.account.bitfinexAccountId])"
                  type="button"
                  class="btn btn-primary w-100" (click)="pushData(item)">Push
          </button>
        </div>
        <div></div>
      </div>
    </td>
  </tr>
  </tbody>
</table>
